import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'undefinedString'
})
export class UndefinedStringPipe implements PipeTransform {

  /**
   * Return 'n/a' instead of the value if it's empty
   * @param {string} value
   * @returns {string}
   */
  transform(value: string): string {
    if (value) {
      return value;
    } else {
      return 'n/a';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/undefined-string.pipe.ts